//
//
//
//

import { changeLang } from '@/utils/lang';
export default {
  name: 'LocalesSwitcher',
  props: {
    white: {
      type: Boolean,
      require: false,
      default: false
    }
  },
  methods: {
    changeLocale: function changeLocale(val) {
      changeLang(val);
    }
  }
};